import React from 'react'
import { Datatable } from '../../componants/dataTable/Datatable';
import { Button } from 'react-bootstrap';
import { BiDownload, BiMoneyWithdraw } from 'react-icons/bi';

const columns = [
    {
        field: "INVOICE_NO",
        header: "Invoice No.",
        align: "center",
    },
    {
        field: "INVOICE_DT",
        header: "Invoice Date",
        align: "center",
    },
    {
        field: "DUE_DT",
        header: "Due Date",
        align: "center",
    },
    {
        field: "BEF_AMT",
        header: "Amount",
        align: "right",
    },
    {
        field: "TOTAL_ITEM",
        header: "Quantity",
        align: "center",
    },
    {
        field: "TAX_AMT",
        header: "Tax Amount",
        align: "right",
    },
    {
        field: "TOTAL_AMT",
        header: "Total Amount",
        align: "right",
    },
    {
        field: "PAID_AMT",
        header: "Paid Amount",
        align: "right",
    },
    {
        field: "DUE_AMT",
        header: "Due Amount",
        align: "right",
    },
    {
        field: "PAYMENT_STATUS",
        header: "Payment Status",
        align: "center",
    },
    {
        field: "Action",
        header: "Action",
        align: "center",
    },
];



const InvoiceTbl = ({ data, invoicegenrate, handlepaymentDetail }) => {
    return (
        <Datatable
            data={data}
            columns={columns}
            tableNm="Invoice"
            pagination={false}
            isSearchBar={false}
            height={255}
        >
            {(child) => (
                <>
                    {child.column.field === "BEF_AMT" && (
                        <span> &#8377; {child.row.BEF_AMT}</span>
                    )}

                    {child.column.field === "TAX_AMT" && (
                        <>
                            <span> &#8377; {child.row.TAX_AMT}</span>
                        </>
                    )}

                    {child.column.field === "TOTAL_AMT" && (
                        <>
                            <span> &#8377; {child.row.TOTAL_AMT}</span>
                        </>
                    )}

                    {child.column.field === "PAID_AMT" && (
                        <>
                            <span> &#8377; {child.row.PAID_AMT}</span>
                        </>
                    )}

                    {child.column.field === "DUE_AMT" && (
                        <>
                            <span> &#8377; {child.row.DUE_AMT}</span>
                        </>
                    )}

                    {child.column.field === "CONFIRM_INVOICE" && (
                        <>
                            <span>
                                {child.row.CONFIRM_INVOICE === "Y" &&
                                    "Confirmed"}
                            </span>
                            <span>
                                {child.row.CONFIRM_INVOICE === "N" &&
                                    "Not Confirmed"}
                            </span>
                        </>
                    )}

                    {child.column.field === "PAYMENT_STATUS" && (
                        <>
                            <span className="badge rounded-pill statusBadgeSuccess">
                                {child.row.PAYMENT_STATUS === "Y" && "Paid"}
                            </span>
                            <span className="badge rounded-pill statusBadgeDanger">
                                {child.row.PAYMENT_STATUS === "N" && "Cancel"}
                            </span>
                            <span className="badge rounded-pill statusBadgeWarning">
                                {child.row.PAYMENT_STATUS === "P" &&
                                    "Pending"}
                            </span>
                            <span className="badge rounded-pill statusBadgeWarning">
                                {child.row.PAYMENT_STATUS === "R" &&
                                    "Return"}
                            </span>
                        </>
                    )}

                    {child.column.field === 'Action' &&
                        <div className='d-flex justify-content-center gap-2'>
                            <Button variant="edit" title='Download Invoice' className="btn-sm rounded-circle" onClick={() => {
                                invoicegenrate(child.row, "DIGITAL")
                            }}><BiDownload /></Button>
                            {child.row.RECEIVED_AMT_FLAG === "Y" &&
                                <Button variant="save" title='Payment Details' className="btn-sm rounded-circle" onClick={() => handlepaymentDetail(child.row)}><BiMoneyWithdraw /></Button>
                            }
                        </div>}

                    {child.column.field !== "BEF_AMT" &&
                        child.column.field !== "TAX_AMT" &&
                        child.column.field !== "TOTAL_AMT" &&
                        child.column.field !== "PAID_AMT" &&
                        child.column.field !== "DUE_AMT" &&
                        child.column.field !== "CONFIRM_INVOICE" &&
                        child.column.field !== "PAYMENT_STATUS" &&
                        child.row[child.column.field]}
                </>
            )
            }
        </Datatable >
    )
}

export default InvoiceTbl;
